export default __webpack_public_path__ + "static/media/ic_gift_error.39a432c3.svg";